<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from "echarts";
import chartResize from "./mixins/chart-resize";

export default {
  name: "PieEchart",
  mixins: [chartResize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "折线图",
    },
    chartData: {
      type: Object,
      required: true,
    },
    xAxisName: {
      type: String,
      default: "日期",
    },
    yAxisName: {
      type: String,
      default: "数量",
    },
    title: {
      type: String,
      default: "客流饱和度",
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        title: {
          text: this.title,
          padding: 0,
          top: 15,
          left: "center",
          textStyle: {
            color: "#fff",
            fontSize: 12,
            fontWeight: "100",
          },
        },

        backgroundColor: "transparent",
        legend: {
          //data，就是取得每个series里面的name属性。2324

          icon: "circle", //图例形状
          padding: 0,
          right: "0",
          bottom: "0",
          left: "center",
          itemWidth: 5, //小圆点宽度
          itemHeight: 5, // 小圆点高度
          itemGap: 10, // 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
          textStyle: {
            fontSize: 12,
            color: "#ffffff",
          },
        },
        tooltip: {
          show: true,
          formatter: "{b}:{d}%",
          confine: true,
        },
        color: [
          "#03acd1",
          "#04cab7",
          "#03c781",
          "#fce348",
          "#fc2d8a",
          "#0292fe",
        ],
        series: [
          {
            name: this.title,
            type: "pie",
            center: ["50%", "50%"], //圆心的位置
            top: "0%", //单单指的饼图距离上面的距离，top越大饼图越小
            left: "10%", //单单指的饼图距离左面的距离，会改变饼图的大小
            right: "10%",
            radius: ["0%", "50%"], //实心圆[内半径=0，外半径] 外半径越大，圆越大
            clockwise: true, //顺时针排列
            startAngle: 90, //起始角度 影响不大
            //roseType:"", // 实心圆 不能出现roseType这个属性
            label: {
              show: true, //false不显示饼图上的标签
              position: "outside", //inside（在饼图上显示）,outside(默认就会出现引导线) center
              formatter: "{b}:{c}",
            },
            //只有设置了label:show=ture;position=outside 设置labelLine才会有效
            labelLine: {
              show: true, //显示引导线
              length: 1, //连接饼图第1段线条的长度 length length2 不写自适应
              length2: 3, //链接饼图第2段线条长度
              smooth: false, //是否光滑连接线
            },
            itemStyle: {
              //每个扇形的设置
              borderColor: "rgba(0,0,0,.1)", //扇形边框颜色
              borderWidth: 1, //扇形边框大小 要先给borderColor颜色 设置borderWidth才会有效果
            },
            data: [
              { value: 104, name: "东门" },
              { value: 735, name: "南门" },
              { value: 580, name: "西门" },
              { value: 484, name: "北门" },
            ].sort((a, b) => b.value - a.value), //数组从大到小排序

            emphasis: {
              //启用鼠标放上去放大效果，这个挺好的
              scale: true,
              scaleSize: 10,
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
  },
};
</script>
